import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * Which Zocdoc environment this deploy is wired to, and which credentials are present —
 * booleans and hosts only, never a secret value. Makes no network call, so the
 * ops page can render it on load.
 */
export const zocdocConfig = oc.route({ method: 'GET', path: '/v2/zocdoc/config' }).output(
  z.object({
    /** Declared via ZOCDOC_ENVIRONMENT. `unknown` means undeclared — the host cannot say. */
    environment: z.enum(['sandbox', 'production', 'unknown']),
    /** Present when the environment is undeclared or disagrees with the host. */
    environmentWarning: z.string().optional(),
    authUrl: z.string().optional(),
    audience: z.string().optional(),
    baseUrl: z.string().optional(),
    /** Presence only. A secret's value never crosses this boundary. */
    hasClientId: z.boolean(),
    hasClientSecret: z.boolean(),
    missingEnv: z.array(z.string()),
  }),
)
